import AddAccount from './AddAccount'

export default AddAccount
